module.exports = __webpack_public_path__ + "img/candidate.40a5ee07.jpeg";